// ⚠️ Siempre al backend, nunca al dominio del front
const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const API_BASE = `${BASE}/api/sucursales/index.php`;

async function jsonOrThrow(res) {
  let data = null;
  try { data = await res.json(); } catch {}
  if (!res.ok) throw new Error(data?.error || `HTTP ${res.status}`);
  if (data && typeof data === "object" && "success" in data && !data.success) {
    throw new Error(data.error || "Operación rechazada");
  }
  return data;
}

export async function apiListarSucursales(params = {}) {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== "")
  ).toString();
  const res = await fetch(`${API_BASE}${qs ? `?${qs}` : ""}`, {
    credentials: "include",
    cache: "no-store",
    headers: { Accept: "application/json" },
  });
  const data = await jsonOrThrow(res);
  return data?.data ?? [];
}

export async function apiObtenerSucursal(id) {
  const res = await fetch(`${API_BASE}?id=${id}`, { credentials: "include" });
  const data = await jsonOrThrow(res);
  return data?.data ?? null;
}

export async function apiCrearSucursal(payload) {
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  const data = await jsonOrThrow(res);
  return data?.data ?? null;
}

export async function apiEditarSucursal(id, payload) {
  const res = await fetch(`${API_BASE}?id=${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  const data = await jsonOrThrow(res);
  return data?.data ?? null;
}

export async function apiDesactivarSucursal(id) {
  const res = await fetch(`${API_BASE}?id=${id}&accion=desactivar`, {
    method: "POST",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  const data = await jsonOrThrow(res);
  return data?.data ?? null;
}

export async function apiReactivarSucursal(id) {
  const res = await fetch(`${API_BASE}?id=${id}&accion=reactivar`, {
    method: "POST",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  const data = await jsonOrThrow(res);
  return data?.data ?? null;
}
